// NOTE: this is importing from rollbar browser because we're using a token that can only
// 'post_client_item' that seems to dictate which version of the SDK you must use.
import Rollbar, { Configuration } from "rollbar/src/browser/core"
import config from "../../pages/_app-config"
import { isClient } from "./rendering"
import { rollbarConfig } from "./rollbar.setup.client"

const cachedRollbars: { [key: string]: Rollbar } = {}

const rollbarClient = (stage: string, options: Configuration): Rollbar | undefined => {
    if (isClient()) return undefined

    const key = options.accessToken || "undefined"

    if (!cachedRollbars[key])
        cachedRollbars[key] = new Rollbar({
            accessToken: options.accessToken,
            enabled: stage === "prod",
            environment: options.environment,
        })
    return cachedRollbars[key]
}

const safeDefaultRollbarClient = () => {
    if (isClient()) return undefined

    try {
        const webAppConfig = config()
        return rollbarClient(webAppConfig.stage, rollbarConfig(webAppConfig))
    } catch (e) {
        console.error("Error creating server-side rollbar client", e)
        return undefined
    }
}

export const defaultRollbarClientServer = safeDefaultRollbarClient()

export default rollbarClient
